import { render, staticRenderFns } from "./SectionClientCourseCompleted.vue?vue&type=template&id=19ba5607&"
import script from "./SectionClientCourseCompleted.vue?vue&type=script&lang=js&"
export * from "./SectionClientCourseCompleted.vue?vue&type=script&lang=js&"
import style0 from "./SectionClientCourseCompleted.vue?vue&type=style&index=0&id=19ba5607&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports